import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  font-family: playfairDisplay !important;
  margin: 0;
  margin-top: 3rem;
  height: min-content;

  @media screen and (max-width: 1680px) {
  }
  @media screen and (max-width: 1280px) {
  }

  @media screen and (max-width: 480px) {
    width: auto;
  }
`;

export const CardWrapper = styled.div`
  width: 60.9375vw;
  max-width: 1140px;
  height: min-content;
  padding: 20px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 0.75fr 1fr;
  margin: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);

  @media screen and (max-width: 1680px) {
  }

  @media screen and (max-width: 1366px) {
    width: 88.88vw;
  }

  @media screen and (max-width: 1024px) {
    width: 60.9375vw;
    display: grid;
    grid-template-columns: none;
    grid-template-rows: 1fr 1fr;
    left: 0rem;
    padding: 0.5rem;
    min-height: 40rem;
    max-height: 50rem;
  }
  @media screen and (max-width: 980px) {
    width: 88.88vw;
    max-width: unset;
  }
  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;

export const Card = styled.div`
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-items: center;
  height: min-content;
  margin: 0;
  padding-left: 1rem;
  padding-right: 1rem;

  @media screen and (max-width: 1680px) {
  }
  @media screen and (max-width: 1280px) {
    &:hover {
      transform: scale(1);
      transition: all 0.2s ease-in-out;
    }
  }
  @media screen and (max-width: 980px) {
    justify-content: center;
    width: 100%;
    min-height: auto;
  }
  @media screen and (max-width: 480px) {
    width: 100%;
    min-height: auto;
  }
`;

export const CardDate = styled.h1`
  font-size: 1rem;
  font-weight: 100;
  color: #000;
  font-style: italic;
  padding-top: 2rem;
  padding-bottom: 0.1rem;
  font-family: playfairDisplay !important;

  @media screen and (max-width: 1680px) {
  }

  @media screen and (max-width: 1280px) {
  }

  @media screen and (max-width: 480px) {
    font-size: 1.4rem;
  }
`;
export const CardPlace = styled.h1`
  font-size: 1rem;
  font-weight: 100;
  color: #000;
  white-space: nowrap;
  width: 25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  padding-bottom: 1rem;
  font-family: playfairDisplay !important;
  font-style: italic;

  @media screen and (max-width: 1680px) {
  }

  @media screen and (max-width: 1280px) {
  }

  @media screen and (max-width: 480px) {
    font-size: 1.2rem;
  }
`;

export const CardTitle = styled.p`
  font-size: 1.8rem !important;
  text-align: center !important;
  white-space: normal !important;
  max-width: 35rem !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  font-family: playfairDisplay !important;

  @media screen and (max-width: 1680px) {
  }

  @media screen and (max-width: 1280px) {
  }

  @media screen and (max-width: 480px) {
    font-size: 1.6rem !important;
    min-width: 90% !important;
    max-width: 90% !important;
  }
`;

export const CardSubtitle = styled.p`
  margin: 0 !important;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
  font-size: 1.2rem !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  font-style: italic !important;
  max-height: 8rem !important;
  max-width: 35rem !important;

  font-family: playfairDisplay !important;

  @media screen and (max-width: 1680px) {
    width: 40rem !important;
  }

  @media screen and (max-width: 1280px) {
  }

  @media screen and (max-width: 480px) {
    width: unset !important;
    margin-left: 1rem !important;
    margin-right: 1rem !important;
    max-width: 50rem !important;
    max-height: 10rem !important;
    text-align: center !important;
  }
`;

export const BtnWrap = styled.div`
  padding-top: 1rem;
  padding-bottom: 2rem;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 1680px) {
  }

  @media screen and (max-width: 1280px) {
  }

  @media screen and (max-width: 480px) {
    padding-bottom: 0;
  }
`;
